import { PropExtend } from '@aksia/infrastructure';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propFind',
  standalone: true,
})
export class PropFindPipe implements PipeTransform {
  transform(
    value: string,
    collection: Array<unknown>,
    searchField: string,
    returnField: string,
  ): unknown {
    let item = collection?.find(
      (item: PropExtend<unknown>) => item[searchField] === value,
    ) as PropExtend<unknown> | undefined;
    return item?.[returnField] ?? value;
  }
}
